import {Link, LinkOwnProps} from 'evergreen-ui';
import {Referral, SiblingReferral} from 'placement/domains';
import {
    getClientPlacementRootUrl,
    parameterizeArray,
    referralOfferDetailUrl
} from "../routes";
import {useLocation} from "react-router";

type Props = {
    referral: Referral
    siblingReferral: SiblingReferral;
} & LinkOwnProps;

export function SiblingReferralOfferDetailLink({referral, siblingReferral, ...linkProps}: Props) {
    const location = useLocation();
    const offerDetailUrl = referralOfferDetailUrl(getClientPlacementRootUrl(location.pathname))
    const referralGuid = siblingReferral.siblingReferralGuid;
    let href = offerDetailUrl + "/" + referralGuid;
    const anotherSiblingGuids = [referral.guid, ...referral.clientSiblingReferralsAllProvider
        .filter((sibling) => sibling.siblingReferralGuid != null)
        .map((sibling) => sibling.siblingReferralGuid)];
    href += parameterizeArray("siblingReferralGuids", anotherSiblingGuids);
    return (
        <Link target="_blank" rel="noopener" href={href} {...linkProps}>
            <span className="text-blue-portal-link">{siblingReferral.siblingCaseNumber}</span>
        </Link>
    );
}
